import * as THREE from 'three';
import { CHUNK_SIZE, WORLD_SIZE_IN_CHUNKS } from '../terrain/TerrainConstants.js';
import { ChunkManager } from '../terrain/TerrainGenerator.js';

export class WorldManager {
    constructor(scene, seed) {
        // Generate or use provided seed
        this.seed = seed || Math.floor(Math.random() * 1000000);
        
        // Set terrain size to cover the entire map (e.g. 32*16 = 512)
        this.terrainSize = CHUNK_SIZE * WORLD_SIZE_IN_CHUNKS;
        this.scene = scene;
        
        // Initialize chunk manager with the scene and seed
        try {
            this.chunkManager = new ChunkManager(scene, this.seed);
            console.log(`[WorldManager] Initialized with seed: ${this.seed}`);
        } catch (error) {
            console.error('[WorldManager] Failed to initialize ChunkManager:', error);
            throw new Error('Failed to initialize world - check console for details');
        }
    }

    setWorldSize(size) {
        this.terrainSize = size;
        this.chunkManager.worldSize = size;
    }

    // Remove getSpawnPoint method as it's no longer needed
    // Spawning is now fully handled by PlayerSpawner
}
